module.exports = __webpack_public_path__ + "static/media/21.45351b09.jpg";